import { EmojiEvents, Warning } from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import { OverdueAndDueDatesResponse } from '../../../../../../../lib/api/fundsDashboard/fundsDashboard';
import EnhacedBox from '../../../../../../../lib/designSystem/Box';

interface TopOverdueTableProps {
  data: OverdueAndDueDatesResponse;
}

const TopOverdueTable: React.FC<TopOverdueTableProps> = ({ data }) => {
  // Función para abreviar el nombre de la empresa
  const abbreviateBusinessName = (name: string, maxLength: number = 25) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + '...';
  };

  // Función para formatear el monto en millones
  const formatAmountInMillions = (amount: number) => {
    const millions = amount / 1000000;
    return `$${millions.toFixed(1)}M`;
  };

  return (
    <EnhacedBox>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 16,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(211, 47, 47, 0.12)',
          }}
        >
          <EmojiEvents sx={{ fontSize: 18, color: '#d32f2f' }} />
        </div>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1.1rem',
          }}
        >
          Facturas con Mayor Morosidad
        </Typography>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f8f9fa' }}>
              <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
                Empresa
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight: 600, fontSize: '0.875rem' }}
              >
                Monto
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight: 600, fontSize: '0.875rem' }}
              >
                Días Mora
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.topOverdueResells?.map((resell, index) => (
              <TableRow
                key={resell.resellId || index}
                sx={{ '&:hover': { bgcolor: '#f5f5f5' } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ fontWeight: 500, fontSize: '0.875rem' }}
                >
                  {abbreviateBusinessName(resell.businessName)}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 500,
                    color: 'error.main',
                    fontSize: '0.875rem',
                  }}
                >
                  {formatAmountInMillions(resell.amount)}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 500,
                    color: 'error.main',
                    fontSize: '0.875rem',
                  }}
                >
                  {resell.overdueDays}
                </TableCell>
              </TableRow>
            )) || []}
          </TableBody>
        </Table>
      </TableContainer>
    </EnhacedBox>
  );
};

export default TopOverdueTable;
